import type { ReactElement } from 'react';
import { ROLE_COPACK_LABELS, type RoleCopack } from '@kn/shared';

const EXPLICATION: Record<RoleCopack, string> = {
  COMPOSE:
    "Composé de copacking : il n'existe pas en comptabilité matières, ses expéditions sont déclarées sous le code composant. Aucun rapprochement code à code n'est possible — la famille est l'unité de comparaison.",
  COMPOSANT:
    'Composant de copacking : la douane ne connaît que lui. Il porte aussi les expéditions du composé.',
};

/**
 * Rôle de copacking d'une ligne — première demande de Léonie.
 *
 * Le badge existe pour une raison précise : sur une grappe de copacking,
 * chercher un écart code à code est une perte de temps garantie. Le dire sur la
 * ligne coûte deux mots ; le laisser découvrir coûte une matinée.
 *
 * Une clé étrangère au copacking n'affiche rien. Un tableau où chaque ligne
 * porte un badge est un tableau où plus aucun badge ne se voit.
 */
export function BadgeCopack({ role }: { role: RoleCopack | null }): ReactElement {
  if (role === null) return <span className="copack-vide">—</span>;

  return (
    <span
      className={`etiquette etiquette--copack etiquette--copack-${role.toLowerCase()}`}
      title={EXPLICATION[role]}
    >
      {ROLE_COPACK_LABELS[role]}
    </span>
  );
}
